export enum ParticipantStatus {
  MISSING_COURSES = 1,
  FINISH_COURSES = 2,
  GRADUATE = 3,
  MISSING_DOCUMENTS = 4,
  MISSING_GRADAUTE_PROJECT = 5,
  MISSING_PAYMENTS = 6,
  CLEARANCE = 7,
  ENROLLED = 8
}

export interface ParticipantStatusOption {
  value: ParticipantStatus;
  label: string;
  cssClass: string;
}

export const PARTICIPANT_STATUS_OPTIONS: ParticipantStatusOption[] = [
  { value: ParticipantStatus.MISSING_COURSES, label: 'Faltan Cursos', cssClass: 'bg-yellow-100 text-yellow-800' },
  { value: ParticipantStatus.FINISH_COURSES, label: 'Cursos Terminados', cssClass: 'bg-blue-100 text-blue-800' },
  { value: ParticipantStatus.GRADUATE, label: 'Graduado', cssClass: 'bg-green-100 text-green-800' },
  { value: ParticipantStatus.MISSING_DOCUMENTS, label: 'Faltan Documentos', cssClass: 'bg-orange-100 text-orange-800' },
  { value: ParticipantStatus.MISSING_GRADAUTE_PROJECT, label: 'Falta Proyecto de Grado', cssClass: 'bg-purple-100 text-purple-800' },
  { value: ParticipantStatus.MISSING_PAYMENTS, label: 'Faltan Pagos', cssClass: 'bg-red-100 text-red-800' },
  { value: ParticipantStatus.CLEARANCE, label: 'En Proceso de Liquidación', cssClass: 'bg-indigo-100 text-indigo-800' },
  { value: ParticipantStatus.ENROLLED, label: 'Inscrito', cssClass: 'bg-green-100 text-green-800' }
];

export const PARTICIPANT_STATUS_LABELS: Record<ParticipantStatus, string> = {
  [ParticipantStatus.MISSING_COURSES]: 'Faltan Cursos',
  [ParticipantStatus.FINISH_COURSES]: 'Cursos Terminados',
  [ParticipantStatus.GRADUATE]: 'Graduado',
  [ParticipantStatus.MISSING_DOCUMENTS]: 'Faltan Documentos',
  [ParticipantStatus.MISSING_GRADAUTE_PROJECT]: 'Falta Proyecto de Grado',
  [ParticipantStatus.MISSING_PAYMENTS]: 'Faltan Pagos',
  [ParticipantStatus.CLEARANCE]: 'En Proceso de Liquidación',
  [ParticipantStatus.ENROLLED]: 'Inscrito'
};

export const PARTICIPANT_STATUS_CSS_CLASSES: Record<ParticipantStatus, string> = {
  [ParticipantStatus.MISSING_COURSES]: 'bg-yellow-100 text-yellow-800',
  [ParticipantStatus.FINISH_COURSES]: 'bg-blue-100 text-blue-800',
  [ParticipantStatus.GRADUATE]: 'bg-green-100 text-green-800',
  [ParticipantStatus.MISSING_DOCUMENTS]: 'bg-orange-100 text-orange-800',
  [ParticipantStatus.MISSING_GRADAUTE_PROJECT]: 'bg-purple-100 text-purple-800',
  [ParticipantStatus.MISSING_PAYMENTS]: 'bg-red-100 text-red-800',
  [ParticipantStatus.CLEARANCE]: 'bg-indigo-100 text-indigo-800',
  [ParticipantStatus.ENROLLED]: 'bg-green-100 text-green-800'
};

// Helper functions for handling inconsistent data from backend
export function normalizeParticipantStatus(status: any): ParticipantStatus | null {
  if (status === null || status === undefined || status === 0 || status === '') {
    return null;
  }
  
  // Handle string values (like "ENROLLED")
  if (typeof status === 'string') {
    const stringToEnum: Record<string, ParticipantStatus> = {
      'MISSING_COURSES': ParticipantStatus.MISSING_COURSES,
      'FINISH_COURSES': ParticipantStatus.FINISH_COURSES,
      'GRADUATE': ParticipantStatus.GRADUATE,
      'MISSING_DOCUMENTS': ParticipantStatus.MISSING_DOCUMENTS,
      'MISSING_GRADAUTE_PROJECT': ParticipantStatus.MISSING_GRADAUTE_PROJECT,
      'MISSING_PAYMENTS': ParticipantStatus.MISSING_PAYMENTS,
      'CLEARANCE': ParticipantStatus.CLEARANCE,
      'ENROLLED': ParticipantStatus.ENROLLED
    };
    return stringToEnum[status.toUpperCase()] || null;
  }
  
  // Handle numeric values
  const numericStatus = Number(status);
  if (isNaN(numericStatus) || numericStatus < 1 || numericStatus > 8) {
    return null;
  }
  
  return numericStatus as ParticipantStatus;
}

export function getParticipantStatusLabel(status: any): string {
  const normalizedStatus = normalizeParticipantStatus(status);
  if (normalizedStatus === null) {
    return 'Sin Definir';
  }
  return PARTICIPANT_STATUS_LABELS[normalizedStatus] || 'Estado Desconocido';
}

export function getParticipantStatusCssClass(status: any): string {
  const normalizedStatus = normalizeParticipantStatus(status);
  if (normalizedStatus === null) {
    return 'bg-gray-100 text-gray-800';
  }
  return PARTICIPANT_STATUS_CSS_CLASSES[normalizedStatus] || 'bg-gray-100 text-gray-800';
}
